import { render, staticRenderFns } from "./MedcertDialog.vue?vue&type=template&id=2145311a&scoped=true&"
import script from "./MedcertDialog.vue?vue&type=script&lang=js&"
export * from "./MedcertDialog.vue?vue&type=script&lang=js&"
import style0 from "./MedcertDialog.vue?vue&type=style&index=0&id=2145311a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145311a",
  null
  
)

export default component.exports